import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import withModal from '../../../../../../components/global/modal/withModal';
import { getAsset } from '../../../../../../util/assets';
import Button from '../../../../../../components/global/Button';

export const DOWNLOADS_CONFIGURATOR_SUCCESS_MODAL =
  'MODAL/DOWNLOADS_CONFIGURATOR_SUCCESS';

const propTypes = {
  onBack: PropTypes.func.isRequired,
  downloadsCount: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
};

const DownloadsConfiguratorSuccessModal = ({
  onBack,
  downloadsCount,
  onClose,
  buttonLabel = 'Back to my event',
}) => {
  return (
    <Fragment>
      <div className="text-center">
        <img
          src={getAsset('/waldo-excited.png')}
          width="60px"
          alt="Waldo Excited"
        />
        <h3 className="text-center mt-2">Configuration Complete!</h3>
        <p className="text-light text-center">
          Check your email soon for delivery of your digital{' '}
          {pluralize('photo', downloadsCount ?? 1)}!
        </p>
        <div className="mx-4">
          <Button
            btnOutline
            btnBlock
            onClick={() => {
              onBack?.();
              onClose?.();
            }}
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

DownloadsConfiguratorSuccessModal.propTypes = propTypes;

export default withModal(DownloadsConfiguratorSuccessModal, {
  name: DOWNLOADS_CONFIGURATOR_SUCCESS_MODAL,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  dismissible: false,
  closeOnOverlayClick: false,
  className: 'downloads-configurator-success-modal',
  overlayClassName: 'downloads-configurator-success-modal-overlay',
});
